import { SharedButton } from "@components";
import { PATH_CHANGE_PASSWORD, dateFormat } from "@configs";
import { IProfile } from "@interfaces";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import styled from "styled-components";
interface IProps {
  data?: IProfile;
}
export const ProfileInfo = ({ data }: IProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const goToChangepassword = async () => {
    await history.push(PATH_CHANGE_PASSWORD);
  };
  return (
    <StyledInner>
      <header>
        <h5>{t("page.contact_admin_info")}</h5>
      </header>
      <StyledList>
        <ItemRow
          label={t("page.provider_joining_date")}
          value={dayjs(data?.createdAt).format(dateFormat) || t("page.empty")}
        />
        <ItemRow label={t("page.label_provider_name")} value={data?.clinicName || "-"} />
        <ItemRow label={t("page.label_provider_email")} value={data?.email || "-"} />
        <ItemRow label={t("page.label_contact_phone_number")} value={data?.phoneNumber || "-"} />
      </StyledList>
      <SharedButton onClick={goToChangepassword} type="primary">
        {t("page.change_password")}
      </SharedButton>
    </StyledInner>
  );
};
interface IItemRow {
  label: string;
  value: string;
}
const StyledList = styled.div`
  width: 100%;
`;
const ItemRow = ({ label, value }: IItemRow) => {
  return (
    <StyledItem>
      <p className="label">{label}</p>
      <p className="value">{value}</p>
    </StyledItem>
  );
};
const StyledItem = styled.article`
  padding: 22px 14px;
  border-bottom: 1px solid #d9d9d9;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .label {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    color: #6f7482;
  }
  .value {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    text-align: right;
    color: #2a2d34;
  }
`;

const StyledInner = styled.section`
  max-width: 600px;
  margin: auto;
  display: flex;
  flex-direction: column;
  row-gap: 40px;
  align-items: center;
  header {
    display: flex;
    justify-content: center;
    align-items: center;
    h5 {
      font-weight: 700;
      font-size: 18px;
      line-height: 25px;
      display: flex;
      align-items: center;
      color: #2a2d34;
    }
  }
`;
